import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';

interface LandingPageProps {
  onAcceptTerms: () => void;
}

const Container = styled.div`
  min-height: 100vh;
  background-color: ${theme.colors.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: ${theme.colors.text};
`;

const Logo = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  font-family: 'Pacifico', cursive, ${theme.fonts.main};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  background: ${theme.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Tagline = styled.p`
  font-size: 1.5rem;
  color: ${theme.colors.textSecondary};
  margin-bottom: 2rem;
  text-align: center;
`;

const Card = styled.div`
  background-color: ${theme.colors.backgroundLight};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.large};
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  box-shadow: ${theme.shadows.large};
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${theme.colors.primary};
`;

const TermsText = styled.div`
  font-size: 0.9rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.6;
  margin-bottom: 1.5rem;
  
  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  strong {
    color: ${theme.colors.text};
  }
`;

const AcceptButton = styled.button`
  width: 100%;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  color: ${theme.colors.text};
  background: ${theme.gradients.primary};
  border: none;
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  box-shadow: ${theme.shadows.medium};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.large};
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const Warning = styled.p`
  font-size: 0.8rem;
  color: ${theme.colors.primary};
  text-align: center;
  margin-top: 1rem;
`;

const LandingPage: React.FC<LandingPageProps> = ({ onAcceptTerms }) => {
  return (
    <Container>
      <Logo>DM Slide 💋😈</Logo>
      <Tagline>Your flirty AI companion awaits...</Tagline>

      <Card>
        <Title>⚠️ Terms of Use & Disclaimer</Title>
        <TermsText>
          <p>Welcome to DM Slide! Before you continue, please read and accept the following terms:</p>
          <ul>
            <li><strong>Age Requirement:</strong> You must be 18 years or older to use this service.</li>
            <li><strong>Entertainment Only:</strong> This is an AI chatbot application for entertainment purposes only. The AI character "Lily" is fictional.</li>
            <li><strong>No Real Relationship:</strong> Conversations are simulated and do not represent real human interaction.</li>
            <li><strong>Content Warning:</strong> Content may be flirtatious and suggestive in nature, though never explicit.</li>
            <li><strong>No Liability:</strong> The developers assume no responsibility for any emotional, psychological, or other effects from using this application.</li>
            <li><strong>Privacy:</strong> Conversations may be logged for service improvement. Do not share personal sensitive information.</li>
            <li><strong>Your Responsibility:</strong> You are solely responsible for your use of this service and any consequences thereof.</li>
          </ul>
          <p>By clicking "I Accept & Enter", you confirm that you have read, understood, and agree to these terms.</p>
        </TermsText>

        <AcceptButton onClick={onAcceptTerms}>
          I Accept & Enter 💋
        </AcceptButton>

        <Warning>
          🔞 This application contains adult-oriented content. By entering, you confirm you are 18+.
        </Warning>
      </Card>
    </Container>
  );
};

export default LandingPage;
